import { blackDuckContinuousDynamic } from "../blackDuckContinuousDynamic/manifest";
import { blackDuckCoverityRest } from "../blackDuckCoverityRest/manifest";
import { blackDuckPolarisPlatform } from "../blackDuckPolarisPlatform/manifest";
import { blackDuckSca } from "../blackDuckSca/manifest";
import { defineProduct } from "../types";
import logo from "./logo.svg";
export const blackDuck = defineProduct({
  name: "Black Duck",
  tagLine: "Application security",
  logo,
  tags: ["security"],
  variants: [
    blackDuckContinuousDynamic,
    blackDuckCoverityRest,
    blackDuckPolarisPlatform,
    blackDuckSca,
  ],
});
